const FIRST_SEEN = 'firstlogin'

const firstLoginKey = (email?: string) => `${FIRST_SEEN}:${(email ?? 'anon').toLowerCase()}`

const safeLS = {
  get: (k: string) => {
    try {
      return localStorage.getItem(k)
    } catch {
      return null
    }
  },
  set: (k: string, v: string) => {
    try {
      localStorage.setItem(k, v)
    } catch {
      return null
    }
  },
  del: (k: string) => {
    try {
      localStorage.removeItem(k)
    } catch {
      return null
    }
  },
}

export { safeLS, firstLoginKey }
